import { useSelector } from 'react-redux'
import { selectAppUser } from 'modules/App/store/selectors'

export const useAuthState = () => {
  const { loading } = useSelector(({ auth }) => auth)
  const user = useSelector(selectAppUser)

  return {
    user,
    isAuthenticated: !!user?.id,
    isSessionPending: loading,
  }
}
